<template>
  <div class="activate-component page white">
    <div class="activate-component-header h-[174px] w-full bg-[#EBECF0]">
      <div class="flex-row flex-row flex justify-between items-end h-full w-[1280px] mx-auto">
        <AssignLicense @newAssignedLicense="handleNewLicenseAssigned($event)"/>
        <LicenseStatusLabel class="mb-[33px]"/>
      </div>
    </div>

    <div class="activate-component-content w-full">
      <div class="w-[1280px] h-[calc(100vh-300px)] flex flex-col wrap mx-auto overflow-y-scroll hide-scrollbar">
        <div class="w-full mx-auto flex-row flex-row flex align-center relative sticky top-0 bg-white">
          <h2 class="font-semibold pt-[30px] text-base">{{$t('activation.yourLicenses')}}</h2>
          <ActivateSearchbar @input="handleSearchText" class="absolute right-0 mt-[12px]"/>
        </div>

        <div class="border border-[#ebecf0] px-px overflow-y-scroll rounded-[8px] hide-scrollbar">
          <ActivateTable
            v-if="licensesTableData"
            :tableColumns="licencesTableColumns"
            :isTableEmpty="isTableEmpty"
            :searchResult="{ isEmpty: isSearchResultEmpty, keyword: this.searchText }"
            :tableData="filteredVisibleLicensesTableData"
            :noEntriesText="$t('activation.noLicensesAvailable')"
            @inputFocus="handleInputFocus"
            @inputChange="handleInputChange"
            @inputBlur="handleInputBlur"
            @inputEnter="handleInputChange"
            @buttonClick="handleButtonClick"
            @sort="handleColumnSort"
            class="ml-0 bg-white text-jet mx-auto border-spacing-0 border-separate"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./activation.js"></script>
